import Bowser from 'bowser';
let systemInfo = undefined;
const getSystemInfo = () => {
    try {
        systemInfo = systemInfo || Bowser.parse(window.navigator.userAgent);
    }
    catch (ex) {
        console.log(`getSystemInfo Error: ${ex}`);
    }
    return systemInfo;
};
export default getSystemInfo;
//# sourceMappingURL=getSystemInfo.js.map